<template>
  <div class="wgtSettings">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="dailysnap">
          <div class="content-panel1 myObs" v-show="IsdayErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">Day of Month Heatmap</h2>
            <apiErrorComponent @tryReload="tryReload" compTitle="Day of Month Heatmap" compId="dailysnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1 myObs" v-show="!IsdayErr">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IsdayErr">
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.daily_heatmap }} You can click on individual days to get more
                insights. <br /><br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to
                    storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart
                    with current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download
                    all the
                    insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isLoaddaily">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isLoaddaily"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">Day of Month Heatmap</h2>
            <div class="panel-body text-center" :class="{ 'BlurClass': !isLoaddaily }">
              <div class="row">
                <div class="col-9">
                  <div id="cal-heatmap" class="heatmapHt" v-show="Isdayshow"></div>
                </div>
                <div class="col-3">
                  <div id="cal-heatmap1" class="heatmapHt" v-show="Isdayshow"></div>
                </div>
              </div>
              <div v-if="Isdaydata" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
            <widgetsSlider :insideArr="dailyInsight" :isInsErr="IsdhInsErr" :isErr="IsdayErr"
              compTitle="Day of Month Heatmap" compId="dailysnap"></widgetsSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue'
import widgetsSlider from '../smallcomp/widgets-slider.vue';
var myChartD, myChartD1;
function reportWindowSizeDT() {
  if (myChartD != undefined) {
    myChartD.resize();
    myChartD1.resize();
  }
}
export default {
  name: 'DailyTrend',
  mixins: [screenShotMix],
  components: {
    widgetDataMsg,
    widgetLoadingComp,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      isLoaddaily: false,
      Isdayshow: false,
      Isdaydata: false,
      IsdayErr: false,
      IsdhInsErr: false,
      dailyInsight: [],
      selectedWord: "",
      selectedWCCol: "",
      screenShort: {
        id: 'dailysnap',
        name: 'dailysnap.png'
      },
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      dailywholedata: null,
    }
  },
  methods: {
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      this.getDailyTrend()
    },
    addToSlider() {
      let insArr = this.dailyInsight;
      let name = "Day of Month Heatmap - " + this.getPins.viewName;
      let screenShort = {
        id: 'dailysnap',
        name: 'dailysnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    downloadDom() {
      let imgname = "Daily_Heatmap.png"
      let widgetID = "dailysnap"
      var geticondiv = document.querySelectorAll('#dailysnap .insideL,#dailysnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = 'Day of Month Heatmap_Insights.txt'
      let insArr
      insArr = this.dailyInsight.join("\r\n")
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    drawDailyTrend() {
      var emit = this.$emit
      let data = []
      let maxVal = 0;
      let chartDom = document.getElementById('cal-heatmap');
      if(chartDom == null) return;
      if (chartDom != null && chartDom != undefined) {
        this.dailywholedata.years = []
        let startYr = parseInt(new Date(this.dailywholedata.heatmapday[0].date * 1000).toISOString()
          .substring(
            0, 4))
        let endYr = parseInt(new Date(this.dailywholedata.heatmapday[this.dailywholedata.heatmapday.length -
          1]
          .date * 1000).toISOString().substring(0, 4))
        for (let index = startYr; index <= endYr; index++) {
          this.dailywholedata.years.push(index.toString())
        }
        chartDom.style.height = this.dailywholedata.years.length * 260 + "px"
        let calendarArr = [];
        let seriesArr = []
        let dataArr = []
        let currYr = startYr
        for (let index = 0; index < this.dailywholedata.heatmapday.length; index++) {
          const element = this.dailywholedata.heatmapday[index];
          if (parseInt(new Date(element.date * 1000).toISOString().substring(0, 4)) != currYr) {
            dataArr.push(data)
            data = []
            currYr = parseInt(new Date(element.date * 1000).toISOString().substring(0, 4))
            data.push([new Date(element.date * 1000).toISOString().slice(0, 10), element.value, element
              .perc
            ]);
          } else {
            data.push([new Date(element.date * 1000).toISOString().slice(0, 10), element.value, element
              .perc
            ]);
          }
          if (maxVal < element.perc) {
            maxVal = element.perc;
          }
        }
        dataArr.push(data)
        for (let index = 0; index < this.dailywholedata.years.length; index++) {
          const element = this.dailywholedata.years[index];
          calendarArr.push({
            top: 250 * index + 50,
            cellSize: ['auto', 25],
            monthLabel: {
              color: '#777'
            },
            dayLabel: {
              color: '#777'
            },
            splitLine: {
              lineStyle: {
                color: "#777",
                width: 2
              }
            },
            range: element,
            itemStyle: {
              color: 'transparent',
              borderWidth: 0.5
            }
          })
          seriesArr.push({
            type: 'effectScatter',
            symbolSize: function (val) {
              let sizeVal = val[2] / maxVal * 10;
              return sizeVal < 4 ? 4 : sizeVal;
            },
            symbol: 'roundRect',
            coordinateSystem: 'calendar',
            data: dataArr[index],
            calendarIndex: index
          })
        }
        var isScatterEffectD = true;
        myChartD = echarts.init(chartDom);
        let option = {
          darkMode: true,
          background: 'transparent',
          tooltip: {
            confine: true,
            formatter: (params) => {
              let monArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep",
                "Oct", "Nov", "Dec"
              ]
              let dtArr = params.data[0].split("-");
              let dtStr = dtArr[2] + " " + monArr[parseInt(dtArr[1]) - 1] + " " + dtArr[0]
              return params.marker + " #Tickets for " + dtStr + " is " + params.data[1] +
                "(" + params
                  .data[2] + "%)";
            },
          },
          toolbox: {
            right: 20,
            itemSize: 20,
            top: 0,
            iconStyle: {
              borderColor: '#777'
            },
            feature: {
              myTool1: {
                show: true,
                title: 'Toggle Animation',
                icon: 'path://M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z',
                onclick: function () {
                  isScatterEffectD = !isScatterEffectD
                  for (let index = 0; index < seriesArr.length; index++) {
                    const element = seriesArr[index];
                    element.type = isScatterEffectD ? 'effectScatter' : 'heatmap';
                  }
                  myChartD.setOption({
                    series: seriesArr
                  })
                }
              },
            },
          },
          visualMap: {
            min: 0,
            calculable: true,
            max: maxVal,
            inRange: {
              color: this.$store.state.chartColor,
            },
            orient: 'horizontal',
            left: 'center',
            top: 0,
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          calendar: calendarArr,
          series: seriesArr
        };
        option && myChartD.setOption(option);
        this.drawSpiderChart()
        myChartD.on('click', function (params) {
          let clickitem;
          if (params.componentType == "yAxis") {
            clickitem = {
              "currpass": params.value + "~null",
              "filterop": "Day~hour"
            }
          } else if (params.componentType == "xAxis") {
            clickitem = {
              "currpass": "null~" + params.value,
              "filterop": "Day~hour"
            }
          } else if (params.componentType == "series") {
            let dateString = params.value[0];
            let year = dateString.substring(0, 4);
            let month = dateString.substring(5, 7);
            let day = dateString.substring(8, 10);
            let date = new Date(year, month - 1, day);
            let selectedWord = ((date.valueOf() / 1000) - (date.getTimezoneOffset() * 60))
              .toString()
            clickitem = {
              "currpass": selectedWord,
              "filterop": "Day~month"
            }
          }
          emit("getKDrill", clickitem)
        });
      }
    },
    drawSpiderChart() {
      var emit = this.$emit
      let chartDom1 = document.getElementById('cal-heatmap1');
      if(chartDom1 == null) return;
      if (chartDom1 != null && chartDom1 != undefined) {
        chartDom1.style.height = "370px"
        myChartD1 = echarts.init(chartDom1);
        let startYr = parseInt(new Date(this.dailywholedata.heatmapday[0].date * 1000).toISOString()
          .substring(0, 4))
        let dataArr = []
        let valueArr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        let currYr = startYr;
        let maxVal = 0;
        for (let index = 0; index < this.dailywholedata.heatmapday.length; index++) {
          const element = this.dailywholedata.heatmapday[index];
          if (parseInt(new Date(element.date * 1000).toISOString().substring(0, 4)) != currYr) {
            dataArr.push({
              value: valueArr,
              name: currYr
            });
            currYr = parseInt(new Date(element.date * 1000).toISOString().substring(0, 4))
            let max = Math.max(...valueArr);
            if (max > maxVal) {
              maxVal = max;
            }
            valueArr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            valueArr[parseInt(new Date(element.date * 1000).toISOString().substring(5, 7)) - 1] +=
              element.value
          } else {
            valueArr[parseInt(new Date(element.date * 1000).toISOString().substring(5, 7)) - 1] +=
              element.value
          }
          dataArr.push({
            value: valueArr,
            name: currYr
          });
          let max = Math.max(...valueArr);
          if (max > maxVal) {
            maxVal = max;
          }
        }
        let option = {
          tooltip: {
            confine: true,
            position: 'inside',
            trigger: 'item',
            textStyle: {
              fontSize: 10,
            },
            formatter: (params) => {
              let tooltipV = "";
              let monArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep",
                "Oct", "Nov", "Dec"
              ]
              for (let index = 0; index < params.value.length; index++) {
                const element = params.value[index];
                if (index % 3 == 0) {
                  tooltipV += "</br>"
                }
                tooltipV += " " + monArr[index] + ":" + "<b>" + element.toLocaleString() +
                  "</b>"
              }
              return params.marker + params.name + tooltipV;
            },
          },
          legend: {
            type: 'scroll',
            textStyle: {
              color: "inherit"
            }
          },
          radar: {
            indicator: [{
              name: 'Jan',
              max: maxVal
            },
            {
              name: 'Feb',
              max: maxVal
            },
            {
              name: 'Mar',
              max: maxVal
            },
            {
              name: 'Apr',
              max: maxVal
            },
            {
              name: 'May',
              max: maxVal
            },
            {
              name: 'Jun',
              max: maxVal
            },
            {
              name: 'Jul',
              max: maxVal
            },
            {
              name: 'Aug',
              max: maxVal
            },
            {
              name: 'Sep',
              max: maxVal
            },
            {
              name: 'Oct',
              max: maxVal
            },
            {
              name: 'Nov',
              max: maxVal
            },
            {
              name: 'Dec',
              max: maxVal
            },
            ],
            triggerEvent: true,
            splitNumber: 5,
            axisName: {
              color: '#777'
            },
            splitLine: {
              lineStyle: {
                color: [
                  'rgba(238, 197, 102, 0.1)',
                  'rgba(238, 197, 102, 0.2)',
                  'rgba(238, 197, 102, 0.3)',
                  'rgba(238, 197, 102, 0.4)',
                  'rgba(238, 197, 102, 0.5)',
                  'rgba(238, 197, 102, 0.6)'
                ].reverse()
              }
            },
            splitArea: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#777'
              }
            }
          },
          series: [{
            type: 'radar',
            data: dataArr
          }]
        };
        option && myChartD1.setOption(option, {
          notMerge: true
        });
        myChartD1.on('click', function (params) {
          let clickitem;
          if (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].includes(params.name)) {
            clickitem = {
              "currpass": "New~" + params.name + "-" + dataArr[0].name,
              "filterop": "InVsCom"
            }
            emit("getKDrill", clickitem)
          }
        });
      }
    },
    getDailyTrend() {
      this.isLoaddaily = false
      this.Isdaydata = false
      this.Isdayshow = false
      this.IsdhInsErr = false
      this.IsdayErr = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/get_dayht_map?asg_id=' + this.asgId, {
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              this.dailywholedata = response.data
              this.dailyInsight = this.dailywholedata.insights
              this.Isdayshow = true
              if (this.dailyInsight.length == 0) {
                this.IsdhInsErr = true
              }
              setTimeout(() => {
                this.drawDailyTrend()
              }, 5)
            } else if (response.data == "Nodata") {
              this.Isdaydata = true
            } else {
              this.IsdayErr = true
              this.$notify({
                type: "error",
                text: 'Something went wrong in Daily Trend Heatmap. Try after sometime!'
              })
            }
            this.isLoaddaily = true
          }
        }).catch((response) => {
          this.IsdayErr = true
          this.isLoaddaily = true
          this.$notify({
            type: "error",
            text: 'Sorry! Something went wrong in Daily Trend Heatmap. Try after sometime!'
          })
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getDailyTrend()
    window.addEventListener("resize", reportWindowSizeDT);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeDT);
  },
  computed: {},
  watch: {
    '$store.state.chartColor': function () {
      if (myChartD != undefined) {
        this.drawDailyTrend()
      }
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.heatmapHt {
  height: 320px;
  overflow: hidden;
}

#cal-heatmap {
  overflow-x: auto;
  overflow-y: hidden;
}

.content-panel1 {
  height: initial;
}</style>